// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation();
jQuery(document).ready(function ($) {
  joints_wp_fixes();
  // AOS.init()  //Enable if loading AOS

  // Fixing FOUC
  setTimeout(function () {
    $('.sticky').css('opacity', '1');
  }, 1200)

  //Smooth Scroll
  $('a[href*="#"]:not([href="#"]):not([role="tab"])').on('click', function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 60
        }, 1000);
        return false;
      }
    }
  });

  if ($(".page-template-template-02_About").length > 0) {
    $('.slick-timeline').slick({
      mobileFirst: true,
      slidesToShow: 1,
      speed: 300,
      prevArrow: $('.arrow-left'),
      nextArrow: $('.arrow-right'),
      cssEase: 'linear',
      centerMode: false,
      draggable: false,
      adaptiveHeight: true,
      dots: true,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            centerMode: true,
            centerPadding: '250px',
            adaptiveHeight: false
          }
        }
      ]
    });
  }



  // // Counts up the percentages
  //   function countUp() {
  //     $(".stat-wrapper .stat").each(function() {
  //       var $this = $(this);
  //       var countTo = $this.attr("data-count");
  //
  //       $({ countNum: $this.text() }).animate(
  //         { countNum: countTo },
  //         {
  //           duration: 1000,
  //           easing: "linear",
  //           step: function() {
  //             $this.text(Math.floor(this.countNum));
  //           },
  //           complete: function() {
  //             $this.text(this.countNum);
  //           }
  //         }
  //       );
  //     });
  //   }
  //   // Initializes the starting of the countUp function
  //   jQuery(".stat-wrapper").appear();
  //   $(".stat-wrapper").on("appear", function() {
  //     countUp();
  //   });

  // Toast Options - https://github.com/CodeSeven/toastr
  // Creator - https://codeseven.github.io/toastr/demo.html
  // Check footer.php for imports

  // toastr.options = {
  //   "closeButton": false,
  //   "debug": false,
  //   "newestOnTop": true,
  //   "progressBar": false,
  //   "positionClass": "toast-top-right",
  //   "preventDuplicates": true,
  //   "onclick": null,
  //   "showDuration": "500",
  //   "hideDuration": "1000",
  //   "timeOut": "2500",
  //   "extendedTimeOut": "1000",
  //   "showEasing": "swing",
  //   "hideEasing": "linear",
  //   "showMethod": "fadeIn",
  //   "hideMethod": "fadeOut"
  // }

  $(".off-canvas").on("opened.zf.offcanvas", function (e) {
    $(".hamburger").toggleClass("is-active");
  });
  $(".off-canvas").on("closed.zf.offcanvas", function (e) {
    $(".hamburger").toggleClass("is-active");
  });

  $(".card.news").hover(
    function () {
      $(".card.news").addClass("blur"), $(this).removeClass("blur");
    },
    function () {
      $(".card.news").removeClass("blur");
    }
  );

  //Find a Broker
  if ($(".page-template-template-11_Find-Broker").length > 0) {

    toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": true,
      "progressBar": false,
      "positionClass": "toast-top-right",
      "preventDuplicates": true,
      "onclick": null,
      "showDuration": "500",
      "hideDuration": "1000",
      "timeOut": "2500",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    if (navigator.geolocation) {

      var options = {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 0,
      };

      function success(position) {
        // console.table(position);
        var lat = position.coords.latitude;
        var long = position.coords.longitude;
        var point = new google.maps.LatLng(lat, long);
        new google.maps.Geocoder().geocode(
          { 'latLng': point },
          function (res, status) {
            var address = res[0].address_components;
            const zip = address.filter(component => component.types[0] === 'postal_code')[0].long_name;
            $("#input_2_1").val(zip);
          }
        );
      }

      function error(err) {
        // console.warn(`ERROR(${err.code}): ${err.message}`);
        // toastr.error("An error has occured while retrieving your location", "GeoLocation Error")
        ipLookUp();
      }

      navigator.geolocation.getCurrentPosition(success, error, options);

    } else {
      toastr.error("Geolocation is not supported by this browser", "GeoLocation Error")
    }
  }
  //http://ip-api.com/docs/api:json
  function ipLookUp() {
    fetch('https://api.ipdata.co?api-key=03908d9a2c6382cecd1d1b4c2cd5ce4e2bc78a651c406050f5bdc23f')
      .then(response => response.json())
      .then(data => {
        $("#input_2_1").val(`${data.city} ${data.postal} ${data.region}`)
        console.log(data)
      })
      .catch(error => toastr.error("An error has occured while retrieving your location", "GeoLocation Error"))
  }

  $('#input_2_1').keypress(function (e) {
    if (e.keyCode == '13') {
      e.preventDefault();
      //your code here
      findBrokers();
    }
  });

  $('#find-a-broker-go-button').on('click', function () {
    findBrokers();
  });

  function findBrokers() {
    // dataLayer.push({'Quote Form': 'Search - start'});
    console.group('New search');
    var postalCode = $("#input_2_1").val();
    console.log(postalCode)
    if (!postalCode) {
      $('#search-success-message').fadeOut('fast');
      $("#brokerCards").html("");
      toastr.warning("Please enter your postal code", "No Postal Code")
      return;
    }

    if ($('#search-success-message').is(':visible')) {
      $('#search-success-message').fadeOut('fast');
    }
    if ($('#search-failure-message').is(':visible')) {
      $('#search-failure-message').fadeOut('fast');
    }

    $('#search-pending-message').fadeIn('slow');

    // $('#get-a-quote-wrapper').show('slow');

    var radius = $("#rangeSlider").val() ? $("#rangeSlider").val() : 25;
    var radiusMax = 50;
    var radiusMin = 1;

    console.log('Current radius ', radius)

    $("#brokerCards").html("");

    console.log('Looking up', postalCode);

    var geocoder = new google.maps.Geocoder();

    let geo_data = { address: postalCode };

    console.log('Checking geo data', geo_data);

    geocoder.geocode(geo_data, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {

        console.log('Geocode results', results)

        var args = {
          latitude: results[0].geometry.location.lat(),
          longitude: results[0].geometry.location.lng(),
          radius: radius,
        }

        console.log('Broker Search Args', args)
        console.groupEnd();
        jQuery.ajax({
          url: '/wp-admin/admin-ajax.php',
          data: {
            'action': 'do_ajax',
            'fn': 'get_brokers',
            'latitude': args.latitude,
            'longitude': args.longitude,
            'radius': args.radius,
          },
          dataType: 'JSON',
          success: function (data) {
            // console.log('distances from lookup point..');
            let brokers = data.brokers;
            // brokers = brokers.filter(function (el) {
            //   return el.should_broker_receive_leads_flag === '1';
            // });

            $('#search-pending-message').fadeOut('fast');
            // if(($('#farm').hasClass('is-active') && !$('#auto').hasClass('is-active') && !$('#commercial').hasClass('is-active') && !$('#residential').hasClass('is-active')) || !$('.lines-of-business-select a').hasClass('is-active')) {
            //   for (var i = brokers.length - 1; i >= 0; --i) {
            //       if (brokers[i].is_rofi == 0) {
            //           brokers.splice(i,1);
            //       }
            //   }
            // }
            if (brokers.length > 0) {
              $('#search-success-message').fadeIn('slow');
            } else {
              $('#search-failure-message').fadeIn('slow');
            }
            console.log('data', data.brokers);
            $.each(brokers, function (idx, broker) {
              console.log('broker', broker)
              addBrokerCard(broker);
            });

          },
          error: function (errorThrown) {
            $('#search-pending-message').fadeOut('fast');
            $('#search-failure-message').fadeIn('slow');
            // dataLayer.push({'Quote Form': 'Search - failure: ' + errorThrown});
            console.log(errorThrown);
          }
        });
        console.groupEnd();
      } else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });
  }

  function addBrokerCard(broker) {
    let html = '<div class="broker card"';

    html += ' data-broker-id="' + broker.ID + '" data-broker-email="' + broker.email + '" data-broker-name="' + broker.post_title + '">';

    html += '<h4>' + broker.post_title + '</h4>';

    if (broker.title)
      html += '<p><strong>' + broker.title + '</strong></p>';
    if (broker.address)
      html += '<p>' + broker.address + '</p>';
    if (broker.toll)
      var tollSlug = slugify(broker.toll);
    html += '<a href="tel:' + tollSlug + '">' + broker.toll + '</a>';
    if (broker.phone)
      var phoneSlug = slugify(broker.phone);
    html += '<a href="tel:' + phoneSlug + '">' + broker.phone + '</a>';
    if (broker.website)
      html += '<a href="' + broker.website + '" target="new">View Website</a>';

    html += '</div>';

    $("#brokerCards").append(html);
  }

  //Slugify function
  function slugify(string) {
    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;'
    const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return string.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with ‘and’
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }
});
